module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"Select Category":"Выбрать категорию"}}')
  delete Component.options._Ctor
}
